(() => {
    function whatsInsideChange() {
        const menu = getEl('.product__discovery__menu')
        if (!menu) return
        const menuItems = menu.querySelectorAll('li')
        if (!menuItems || !menuItems.length) return
        for (let i = 0; i < menuItems.length; i++) {
            const li = menuItems[i]
            li.addEventListener('click', function (e) {
                const thisNavItem = e.target
                const isCurrent = classHelper(thisNavItem, 'c', 'current')
                if (isCurrent) return
                const selectedNavItem = getEl('.product__discovery__menu .current')
                if (selectedNavItem) classHelper(selectedNavItem, 'r', 'current')
                classHelper(thisNavItem, 'a', 'current')
                const handle = thisNavItem.getAttribute('data-target')
                const activeContentContainer = getEl('.product__discovery__container.current')
                if (activeContentContainer) classHelper(activeContentContainer, 'r', 'current')
                const contentContainerTarget = getEl(`.discovery__container__${handle}`)
                if (contentContainerTarget) classHelper(contentContainerTarget, 'a', 'current')
            })
        }
    }

    document.readyState !== 'loading' ? whatsInsideChange() : document.addEventListener('DOMContentLoaded', whatsInsideChange);
})();
